module.exports = __webpack_public_path__ + "static/media/car@2x.9ae25457.png";